import { Subject } from "rxjs";
import { merge, get } from "lodash-es";
import { replacePlaceholders, redirect } from "@odin/utils";
import i18next from "i18next";
import Axios from "axios";
var Bundler = /* @__PURE__ */ ((Bundler2) => {
  Bundler2[Bundler2["rollup"] = 0] = "rollup";
  Bundler2[Bundler2["webpack"] = 1] = "webpack";
  return Bundler2;
})(Bundler || {});
var Theme = /* @__PURE__ */ ((Theme2) => {
  Theme2["ADMIN"] = "admin";
  Theme2["CARY"] = "cary";
  Theme2["LOOPIA"] = "loopia";
  Theme2["ACTIVE_24"] = "active24";
  return Theme2;
})(Theme || {});
var CompanyId = /* @__PURE__ */ ((CompanyId2) => {
  CompanyId2["WEBSUPPORT_SK"] = "sk-ws";
  CompanyId2["SK_WEBSUPPORT_CZ"] = "cz-ws";
  CompanyId2["WEBSUPPORT_HU"] = "hu-ws";
  CompanyId2["WEBSUPPORT_SE"] = "se-ws";
  CompanyId2["SK_WEBSUPPORT_HU"] = "hu-skws";
  CompanyId2["ACTIVE_24_SK"] = "sk-a24";
  CompanyId2["ACTIVE_24_CZ"] = "cz-a24";
  CompanyId2["SK_WEBSUPPORT_AT"] = "at-ws";
  CompanyId2["LOOPIA_SE"] = "se-lp";
  CompanyId2["LOOPIA_NO"] = "no-lp";
  return CompanyId2;
})(CompanyId || {});
const cfgChangesSubject = new Subject();
const configObservable = cfgChangesSubject.asObservable();
const config = {
  // default config values
  companyCountry: "SK",
  phonePrefixes: [],
  bounds: {
    east: 16.8799829444,
    south: 47.7584288601,
    west: 22.5581376482,
    north: 49.5715740017
  },
  languages: {},
  currency: "EUR",
  validationApiUrl: "https://api-cart.websupport.sk/",
  bundler: Bundler.webpack
};
function setConfigValues(newValues) {
  merge(config, newValues);
  cfgChangesSubject.next(config);
}
let _axios;
let _messageService;
let _refs;
let _nextTick;
const setupActions = (axios, messageService, refs, nextTick, WsDialog) => {
  _axios = axios;
  _messageService = messageService;
  _refs = refs;
  _nextTick = nextTick;
};
const useActions = () => {
  return {
    responseAction,
    actionClicked
  };
};
const responseAction = async (data, headers, opts = {}) => {
  if (opts.processResponseCallback) {
    opts = {
      ...opts,
      ...opts.processResponseCallback(data, headers, { singleAction: true })
    };
  }
  const actionPromise = new Promise((res) => {
    res(executeAction(data, headers, opts));
  });
  return {
    actionPromise,
    killAction: () => {
    }
  };
};
function getPollUrl(data, opts) {
  return (data == null ? void 0 : data.action) === "poll" ? data.url || (opts == null ? void 0 : opts.poll) : opts == null ? void 0 : opts.poll;
}
function getRedirectUrl(data, opts) {
  return (data == null ? void 0 : data.action) === "redirect" ? data.url || (opts == null ? void 0 : opts.redirect) : (data == null ? void 0 : data.redirectTo) || (opts == null ? void 0 : opts.redirect);
}
function handleDialog(opts, dialogAction = "toggle") {
  if (opts == null ? void 0 : opts.openModal) {
    const dialog = _refs[opts.openModal];
    _nextTick(() => {
      dialog ? dialog[dialogAction]() : console.error(`Modal ${opts.openModal} not found`);
    });
  }
}
async function handlePollingDialog(opts, formattedPollUrl, pollLimit) {
  handleDialog(opts, "show");
  if (!formattedPollUrl) {
    handleDialog(opts, "hide");
    return false;
  }
  await pollStatusAfterSubmit(formattedPollUrl, pollLimit, opts);
  handleDialog(opts, "hide");
  return false;
}
const executeAction = async (data, headers, opts) => {
  const contentHeader = headers["content-disposition"];
  const isFileDownload = contentHeader == null ? void 0 : contentHeader.includes("attachment");
  if (isFileDownload) {
    const fileName = contentHeader.replaceAll(/"/g, "").slice(contentHeader.indexOf("=") + 1);
    executeFileDownload(data, headers, fileName);
    return false;
  }
  const replacementData = get(data, "data", data);
  const pollUrl = getPollUrl(data, opts);
  const pollLimit = 30;
  const formattedPollUrl = replacePlaceholders(pollUrl, replacementData);
  const redirectUrl = replacePlaceholders(getRedirectUrl(data, opts), replacementData);
  if (formattedPollUrl) {
    if (opts == null ? void 0 : opts.openModal) {
      return handlePollingDialog(opts, formattedPollUrl, pollLimit);
    } else {
      opts = await pollStatusAfterSubmit(formattedPollUrl, pollLimit, opts) || { redirectUrl };
    }
  }
  if (redirectUrl || opts.redirect) {
    redirect(redirectUrl ?? opts.redirect);
    return true;
  }
  if (opts == null ? void 0 : opts.reload) {
    window.location.reload();
    return true;
  }
  handleDialog(opts);
  handleFlashMessages(headers);
  if (opts == null ? void 0 : opts.reloadComponents) {
    reloadComponents(opts.reloadComponents);
    return false;
  }
  return false;
};
function handleFlashMessages(headers) {
  var _a;
  if ((_a = headers["x-flash-messages"]) == null ? void 0 : _a.length) {
    if (_messageService) {
      _messageService.setFlashMessages(JSON.parse(headers["x-flash-messages"]));
    } else {
      console.error("Message service not configured");
    }
  }
}
function reloadComponents(componentsToReload) {
  componentsToReload.forEach((cmp) => {
    var _a;
    (_a = _refs[cmp]) == null ? void 0 : _a.reload();
  });
}
const pollStatusAfterSubmit = (url, limit, opts) => (
  // eslint-disable-next-line sonarjs/cognitive-complexity
  new Promise(async (res, rej) => {
    if (limit <= 0) {
      return rej("Server polling exceeded it's connection limit.");
    }
    try {
      const { data, headers, status } = await _axios({ url });
      if (status === 200) {
        if (opts.processResponseCallback) {
          return res(opts.processResponseCallback(data, headers, { pollingAction: true }));
        } else {
          if (data.redirectTo) {
            return res({
              ...opts,
              redirect: data.redirectTo
            });
          } else {
            return res(opts);
          }
        }
      }
    } catch (err) {
      console.error(err);
    }
    setTimeout(async () => {
      try {
        res(await pollStatusAfterSubmit(url, limit - 1, opts));
      } catch (err) {
        rej(err);
      }
    }, 2e3);
  })
);
const executeFileDownload = (data, headers, fileName) => {
  const blob = new Blob([data], { type: headers["content-type"] });
  const href = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};
const actionClicked = async (action, context, actionUrl) => {
  context == null ? void 0 : context.$emit("action-clicked", action);
  if (context == null ? void 0 : context.isDisabled) {
    context == null ? void 0 : context.disabledBulkActionData.disabledBulkActionHandler(action.name);
    return;
  }
  if (context == null ? void 0 : context.onSuccess) {
    action.onSuccess = context.onSuceess;
  }
  if (action.ajax) {
    context == null ? void 0 : context.$emit("ajax-action-call", action);
  } else if (typeof action.clicked === "function") {
    action.clicked(action);
  } else if (action.modalRef && (context == null ? void 0 : context.$root.$refs[action.modalRef])) {
    await handleDialogAction(action, context);
  } else if (action.url || action.urlExpression) {
    handleRedirectAction(action, actionUrl);
  }
  return false;
};
const handleRedirectAction = (action, actionUrl) => {
  var _a;
  if (((_a = action == null ? void 0 : action.attributes) == null ? void 0 : _a.target) === "_blank") {
    window.open(actionUrl || action.url, "_blank");
  } else {
    redirect(actionUrl || action.url);
  }
};
const handleDialogAction = async (action, context) => {
  if (action.rowData) {
    (context == null ? void 0 : context.$root).$wData.set("modalData", {
      action,
      rowData: action.rowData
    });
  }
  const cta = action;
  const formData = action.rowData;
  await (context == null ? void 0 : context.$nextTick());
  let wsDialog = context == null ? void 0 : context.$root.$refs[action.modalRef];
  if (wsDialog && action.refIndex !== void 0) {
    wsDialog = get(wsDialog, action.refIndex, wsDialog);
  }
  if (wsDialog) {
    wsDialog.setModalData(action.rowData);
    setTimeout(() => {
      wsDialog.toggle();
    }, 0);
  }
  if (context == null ? void 0 : context.emitInActions) {
    await (context == null ? void 0 : context.$nextTick());
    context == null ? void 0 : context.emitInActions("show-cta-modal", action.modalRef, { cta, rowData: formData });
  }
};
const __variableDynamicImportRuntimeHelper = (glob, path, segs) => {
  const v = glob[path];
  if (v) {
    return typeof v === "function" ? v() : Promise.resolve(v);
  }
  return new Promise((_, reject) => {
    (typeof queueMicrotask === "function" ? queueMicrotask : setTimeout)(
      reject.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + path + (path.split("/").length !== segs ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
let loadProjectLanguage = async (_lang) => ({});
let languages = [];
function useI18n() {
  return {
    setLang: async (lang) => {
      await loadLanguage(lang);
      i18next.changeLanguage(lang);
    },
    getLang: () => i18next.language,
    getLanguages: () => i18next.languages,
    t: translateWithFallback,
    i18next
  };
}
async function setupI18n(opt) {
  if (opt.loadLanguage) {
    loadProjectLanguage = opt.loadLanguage;
  }
  languages = opt.supportedLanguages;
  await i18next.init({
    lng: opt.language,
    supportedLngs: opt.supportedLanguages,
    fallbackLng: ["en-US", "en-SE"],
    lowerCaseLng: false,
    defaultNS: opt.defaultNS,
    returnNull: true,
    ns: ["app", "uikit"],
    debug: !!opt.debug,
    interpolation: {
      prefix: "{",
      suffix: "}"
    }
  });
  await loadLanguage(opt.language);
  return i18next;
}
function translateWithFallback(key, values) {
  const exact = i18next.t(key, values);
  if (exact !== key) {
    return exact;
  }
  console.error(`i18next: Missing translation for key: ${key}`);
  return i18next.t(key, { ...values, lng: "source" }) || key;
}
function loadLanguage(lang) {
  return Promise.all([
    loadAndSetProjectLanguage(lang),
    loadAndSetUikitLanguage(lang)
  ]);
}
async function loadAndSetProjectLanguage(lang) {
  const resources = await loadProjectLanguage(lang);
  i18next.addResourceBundle(lang, "app", resources, true, true);
}
async function loadAndSetUikitLanguage(lang) {
  const resources = await __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "./translations/wsk.cs-CZ.json": () => import("./wsk.cs-CZ-C5wK8bLX.js"), "./translations/wsk.en-SE.json": () => import("./wsk.en-SE-BwcAQDth.js"), "./translations/wsk.en-US.json": () => import("./wsk.en-US-BVB6m8lL.js"), "./translations/wsk.hu-HU.json": () => import("./wsk.hu-HU-BNassfbV.js"), "./translations/wsk.sk-SK.json": () => import("./wsk.sk-SK-DCrrbtwV.js"), "./translations/wsk.sv-SE.json": () => import("./wsk.sv-SE-Ddkaj9Ft.js"), "./translations/wsk.xx-XX.json": () => import("./wsk.xx-XX-BsKCxDi9.js") }), `./translations/wsk.${lang}.json`, 3);
  i18next.addResourceBundle(lang, "uikit", resources["wsk"], true, true);
}
const supportedLanguages = {
  en: "English",
  gb: "English",
  sk: "Slovensky",
  cs: "Česky",
  cz: "Česky",
  hu: "Magyar",
  de: "Deutsch",
  sv: "Swedish",
  se: "Swedish"
  // xx: 'Crowdin',
};
const getLanguageName = (code) => supportedLanguages[code.toLowerCase()] || code;
function localeToFlagCode(code) {
  const useSecondPartLocales = [
    "cs-CZ",
    "sv-SE"
  ];
  const partIndex = useSecondPartLocales.includes(code) ? 1 : 0;
  let flagCode = code.split("-")[partIndex] || "";
  if (flagCode.toLowerCase() === "en") {
    flagCode = "gb";
  }
  return flagCode;
}
function getAllowedLanguages(companyId) {
  let languages2 = [];
  if ([CompanyId.WEBSUPPORT_SE, CompanyId.LOOPIA_SE].includes(companyId)) {
    languages2 = [
      "en-SE",
      "sv-SE"
    ];
  } else {
    languages2 = [
      "cs-CZ",
      "hu-HU",
      "en-US",
      "sk-SK"
    ];
  }
  return languages2;
}
const normalizers = [
  normalizeLaravel,
  normalizeAxios
];
const normalizeError = (err, translate2) => {
  for (const normalizer of normalizers) {
    const output = normalizer(err, translate2);
    if (output) {
      return output;
    }
  }
  return normalizeUnexpected(err, translate2);
};
function normalizeLaravel(err, _translate) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  if (((_a = err == null ? void 0 : err.response) == null ? void 0 : _a.status) === 422 && ((_c = (_b = err == null ? void 0 : err.response) == null ? void 0 : _b.data) == null ? void 0 : _c.type) === "/errors/validation" && typeof ((_e = (_d = err == null ? void 0 : err.response) == null ? void 0 : _d.data) == null ? void 0 : _e.violations) && Array.isArray((_g = (_f = err == null ? void 0 : err.response) == null ? void 0 : _f.data) == null ? void 0 : _g.violations)) {
    return (_j = (_i = (_h = err == null ? void 0 : err.response) == null ? void 0 : _h.data) == null ? void 0 : _i.violations) == null ? void 0 : _j.reduce((acc, violation) => {
      acc[violation.errors[0].propertyPath] = {
        value: violation.errors[0].translation,
        payload: {
          title: err.title,
          text: violation.errors[0].translation,
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      };
      return acc;
    }, {});
  }
}
function normalizeAxios(err, translate2) {
  var _a, _b, _c, _d, _e;
  if ((err == null ? void 0 : err.code) === "ERR_NETWORK" && (err == null ? void 0 : err.name) === "AxiosError" && (err == null ? void 0 : err.message) === "Network Error") {
    return {
      0: {
        value: "Unable to Connect ",
        payload: {
          title: translate2("uikit:message_service.error.axios.title"),
          text: translate2("uikit:message_service.error.axios.text"),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      }
    };
  } else if (((_a = err == null ? void 0 : err.response) == null ? void 0 : _a.status) === 401) {
    return {
      0: {
        value: "Authentication error",
        payload: {
          text: translate2("uikit:message_service.error.status_401.text"),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      }
    };
  } else if (((_b = err == null ? void 0 : err.response) == null ? void 0 : _b.status) === 403) {
    return {
      0: {
        value: "Access denied",
        payload: {
          text: translate2("uikit:message_service.error.status_403.text"),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      }
    };
  } else if ((err == null ? void 0 : err.code) === "ERR_BAD_REQUEST" && (err == null ? void 0 : err.name) === "AxiosError" && (err == null ? void 0 : err.message) === "Request failed with status code 404") {
    return {
      0: {
        value: "Not found",
        payload: {
          text: translate2("uikit:message_service.error.status_404.text"),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      }
    };
  } else if (((_c = err == null ? void 0 : err.response) == null ? void 0 : _c.status) === 407) {
    return {
      0: {
        value: "Proxy authentication required",
        payload: {
          text: translate2("uikit:message_service.error.status_407.text"),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      }
    };
  } else if (((_d = err == null ? void 0 : err.response) == null ? void 0 : _d.status) === 408) {
    return {
      0: {
        value: "Connection timeout",
        payload: {
          text: translate2("uikit:message_service.error.status_408.text"),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      }
    };
  } else if (((_e = err == null ? void 0 : err.response) == null ? void 0 : _e.status) === 500) {
    return {
      0: {
        value: "Server error",
        payload: {
          text: translate2("uikit:message_service.error.status_500.text"),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      }
    };
  }
}
function normalizeUnexpected(err, translate2) {
  let text = translate2("uikit:message_service.error.unexpected.text");
  let errorInstance = new Error("Unexpected error", err);
  if (err instanceof Error) {
    if (err.message) {
      text = err.message;
    }
    errorInstance = err;
  } else if (typeof err === "string") {
    text = err;
    errorInstance = new Error(err);
  }
  return {
    0: {
      value: text,
      payload: {
        title: translate2("uikit:message_service.error.unexpected.title"),
        text,
        icon: true,
        closable: true,
        type: "error"
      },
      error: errorInstance
    }
  };
}
let messages = {};
const subscriptions = {
  messages: {},
  topics: {}
};
let postInterceptor = (message, topics) => message;
let onChange = () => {
};
let translate = (key) => key;
function setupMessages(options) {
  if (options.postInterceptor) {
    postInterceptor = options.postInterceptor;
  }
  if (options.translate) {
    translate = options.translate;
  }
  if (options.onChange) {
    onChange = options.onChange;
  }
}
function useMessages() {
  return {
    // Read
    getMessages: (key) => messages[key],
    getAllMessages: () => messages,
    subscribeMessage: (messageKey, callback) => registerSubscriber("messages", messageKey, callback),
    subscribeTopic: (topicKey, callback) => registerSubscriber("topics", topicKey, callback),
    // Posting
    postMessage: (key, message, topics = []) => {
      post(key, message, normalizeTopics(topics));
    },
    postError: (key, errorMessage, topics = []) => {
      post(key, errorMessage, normalizeTopics(topics, ["error"]));
    },
    handleUnstructuredError: (prefix, error, topics = []) => {
      const errorMessages = normalizeError(error, translate);
      const messages2 = Object.entries(errorMessages);
      if (messages2.length === 1) {
        return post(prefix, messages2[0][1], normalizeTopics(topics, ["error"]));
      }
      messages2.forEach(([postfix, message]) => {
        post(prefix + "." + postfix, message, normalizeTopics(topics, ["error"]));
      });
    },
    // Clear
    clearMessages: () => {
      messages = {};
      onChange(messages);
    },
    deleteMessage: (key) => {
      delete messages[key];
      onChange(messages);
    }
  };
}
function registerSubscriber(type, key, callback) {
  if (!subscriptions[type][key]) {
    subscriptions[type][key] = [];
  }
  const id = subscriptions[type][key].length;
  const unsubscribe = () => subscriptions[type][key].splice(id, 1);
  subscriptions[type][key].push({ id, callback, unsubscribe });
  return subscriptions[type][key][id];
}
function post(key, message, topics) {
  var _a;
  message.toString = function() {
    return this.value;
  };
  messages[key] = postInterceptor(message, topics);
  const triggerCallback = (sub) => sub.callback(message, key, topics);
  (_a = subscriptions["messages"][key]) == null ? void 0 : _a.forEach(triggerCallback);
  topics.forEach((topic) => {
    var _a2;
    return (_a2 = subscriptions["topics"][topic]) == null ? void 0 : _a2.forEach(triggerCallback);
  });
  onChange(messages);
}
function normalizeTopics(topics, topicsToAdd = []) {
  const formattedTopics = typeof topics === "string" ? [topics] : topics;
  topicsToAdd.forEach((topic) => {
    if (!formattedTopics.includes(topic)) {
      formattedTopics.push(topic);
    }
  });
  return formattedTopics;
}
let _theme = void 0;
const _onThemeListeners = [];
const _isTheme = (theme) => {
  return _theme === theme;
};
const _setTheme = (theme) => {
  _theme = theme;
  _onThemeListeners.forEach((listener) => {
    listener(theme);
  });
};
function useTheming() {
  return {
    isTheme: _isTheme,
    setTheme: _setTheme,
    theme: _theme,
    onTheme
  };
}
function setupTheming(opt) {
  _setTheme(opt.theme);
  if (opt.onTheme) {
    onTheme(opt.onTheme);
  }
  if (opt.env === "development") {
    window.setTheme = _setTheme;
    window.isTheme = _isTheme;
  }
}
function onTheme(callback) {
  _onThemeListeners.push(callback);
}
const network = Axios.create({ withCredentials: false });
const useAutoComplete = () => ({
  getAutofillSuggestions
});
function getAutofillSuggestions({
  name = null,
  cin = null,
  limit = 5,
  filter = "active"
}) {
  const apiToken = "f639d8d3ff0b9172721f468f8d71c99699cbcda3366b6ac7278446f012fc538483a62815865264cc";
  if (!name && !cin) {
    return Promise.reject();
  }
  const q = name ? `name:${name}` : `cin:${cin}`;
  const endpoint = "https://autoform.ekosystem.slovensko.digital/api/corporate_bodies/search?q=" + encodeURIComponent(q) + "&limit=" + encodeURIComponent(limit) + "&filter=" + encodeURIComponent(filter) + "&private_access_token=" + apiToken;
  return network.get(endpoint).then((result) => {
    return result.data;
  }).catch(() => []);
}
let currentPosition = null;
const predictionsCache = new Object(null);
let placeService;
let autocompleteService;
let googleLocal;
let google;
const useGoogleAPI = () => ({
  askForLocation,
  getPlacePredictions,
  getPlaceAddress,
  parseCityFromComponents,
  parseStreetFromComponents,
  parseAddressComponents
});
const setupGoogleAPI = (newGoogle) => {
  google = newGoogle;
  googleLocal = typeof google === "undefined" ? null : google;
  if (!googleLocal) {
    setWaitTimeout(100);
  }
  autocompleteService = googleLocal && googleLocal.maps ? new googleLocal.maps.places.AutocompleteService(
    document.createElement("input")
  ) : {};
  placeService = googleLocal && googleLocal.maps ? new googleLocal.maps.places.PlacesService(document.createElement("div")) : {};
};
function askForLocation() {
  if (!currentPosition && navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        currentPosition = position.coords;
      },
      () => {
      },
      {
        enableHighAccuracy: false,
        maximumAge: 5e3
      }
    );
  }
}
function getPlacePredictions(input, types = "(cities)") {
  if (!googleLocal) {
    return Promise.reject(new Error("google not loaded"));
  }
  if (!input) {
    return Promise.resolve([]);
  }
  const hash = `${input}::${types}`;
  if (predictionsCache[hash]) {
    return Promise.resolve(predictionsCache[hash]);
  }
  return new Promise((resolve, reject) => {
    autocompleteService.getPlacePredictions(
      {
        input,
        types: [types],
        // specifying location and radius did not enhance results, for example for
        // Sedmerovec 93 address.. it did not find it neither
        // therefore I am not going to make code more complex, without any value
        ...currentPosition ? {
          radius: 5e3,
          location: new google.maps.LatLng(
            currentPosition.latitude,
            currentPosition.longitude
          )
        } : {
          // fallbacks to whole europe
          bounds: config.bounds || {
            east: -24.550781,
            south: 34.741612,
            west: 40.605468,
            north: 71.244356
          }
        }
      },
      (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          predictionsCache[hash] = results;
          resolve(results);
        } else {
          reject({ results, status });
        }
      }
    );
  });
}
function getPlaceAddress(placeId) {
  return new Promise((resolve, reject) => {
    placeService.getDetails(
      {
        placeId,
        fields: ["address_components"]
      },
      (result, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          resolve(parseAddressComponents(result.address_components));
        } else {
          reject({ result, status });
        }
      }
    );
  });
}
function parseStreetFromComponents(components) {
  const street = components.route;
  const number = components.street_number || components.queryNumberParts || "";
  return street && number ? `${street} ${number}` : street || number;
}
function parseCityFromComponents(components) {
  return components.postal_town || components.locality || components.sublocality || components.sublocality_level_5 || components.sublocality_level_4 || components.sublocality_level_3 || components.sublocality_level_2 || components.sublocality_level_1 || components.administrative_area_level_5 || components.administrative_area_level_4 || components.administrative_area_level_3 || components.administrative_area_level_2 || components.administrative_area_level_1 || "";
}
function parseAddressComponents(address_components = []) {
  const parsed_components = {};
  const componentsLength = address_components.length;
  for (let i = 0; i < componentsLength; ++i) {
    const component = address_components[i];
    const types = component.types;
    for (let ii = 0; ii < types.length; ++ii) {
      const type = types[ii];
      parsed_components[type] = component.long_name;
      if (type === "country") {
        parsed_components.country_code = component.short_name;
      }
    }
  }
  return parsed_components;
}
function setWaitTimeout(time) {
  setTimeout(() => {
    if (time > 3e4) {
      return;
    }
    googleLocal = typeof google === "undefined" ? null : google;
    if (!googleLocal) {
      setWaitTimeout(time *= 2);
    } else {
      autocompleteService = new googleLocal.maps.places.AutocompleteService();
      placeService = new googleLocal.maps.places.PlacesService(
        document.createElement("div")
      );
    }
  }, time);
}
export {
  Bundler,
  CompanyId,
  Theme,
  actionClicked,
  config,
  configObservable,
  getAllowedLanguages,
  getLanguageName,
  languages,
  localeToFlagCode,
  responseAction,
  setConfigValues,
  setupActions,
  setupGoogleAPI,
  setupI18n,
  setupMessages,
  setupTheming,
  supportedLanguages,
  useActions,
  useAutoComplete,
  useGoogleAPI,
  useI18n,
  useMessages,
  useTheming
};
//# sourceMappingURL=index.es.js.map
